import { fmtDate } from "@/lib/format";
import { lastSeenOf, usagePctOf } from "@/lib/usage";
import { L } from "@/i18n";

const na = () => L("Not provided by the API yet", "Ainda não fornecido pela API");

export const LastSeenCell = ({ user }) => {
  const v = lastSeenOf(user);
  if (!v) return <span className="font-mono text-xs text-slate-600" title={na()}>—</span>;
  return <span className="font-mono text-xs text-slate-300 whitespace-nowrap">{fmtDate(v, "dd MMM yyyy, HH:mm")}</span>;
};

export const UsageCell = ({ user }) => {
  const pct = usagePctOf(user);
  if (pct == null) return <span className="font-mono text-xs text-slate-600" title={na()}>—</span>;
  const color = pct >= 50 ? "#10b981" : pct >= 20 ? "#f59e0b" : "#f43f5e";
  return (
    <div className="flex items-center gap-2 min-w-[90px]" title={L("App usage in the last 30 days", "Utilização da app nos últimos 30 dias")}>
      <div className="h-1.5 w-12 rounded-full bg-slate-800 overflow-hidden">
        <div className="h-full rounded-full" style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="font-mono text-xs text-slate-300">{pct}%</span>
    </div>
  );
};
